import firebase from "firebase";

export const getAuthHeaders = async () => {
  const token = await firebase.auth().currentUser?.getIdToken();
  return { Authorization: `Bearer ${token}` };
};
